import {
  faArrowDownToLine,
  faClone,
  faDatabase,
  faTrashCan,
} from "@fortawesome/pro-regular-svg-icons";
import React from "react";

import { EllipsisOptionsDropdown } from "src/base-components/OptionsDropdown/EllipsisOptionsDropdown";
import { MENU_DIVIDER } from "src/base-components/OptionsDropdown/OptionsDropdownItems";
import { isFeatureFlagEnabled } from "src/router/featureFlags";

type SimulationOptionsDropdownProps = {
  onDelete: () => void;
  hasFailedRows: boolean;
  hasSuccessfulRows: boolean;
  isCompleted: boolean;
  isDatasetCreationPending: boolean;
  onCreateFailedDataset: () => void;
  onDownloadCsv: () => void;
  onDownloadNdjson: () => void;
  onCopyCsvUrl: () => void;
  onCopyNdjsonUrl: () => void;
};

export const SimulationOptionsDropdown: React.FC<
  SimulationOptionsDropdownProps
> = ({
  onDelete,
  hasFailedRows,
  hasSuccessfulRows,
  isCompleted,
  onCreateFailedDataset,
  onDownloadCsv,
  onDownloadNdjson,
  onCopyCsvUrl,
  onCopyNdjsonUrl,
}) => {
  const optionsElements = [];
  if (isCompleted && hasSuccessfulRows) {
    if (isFeatureFlagEnabled("notebooks")) {
      optionsElements.push({
        key: "Copy CSV URL",
        icon: faClone,
        action: onCopyCsvUrl,
      });
      optionsElements.push({
        key: "Copy NDJSON URL",
        icon: faClone,
        action: onCopyNdjsonUrl,
      });
    }
    optionsElements.push({
      key: "Download as CSV",
      icon: faArrowDownToLine,
      action: onDownloadCsv,
    });
    optionsElements.push({
      key: "Download as NDJSON",
      icon: faArrowDownToLine,
      action: onDownloadNdjson,
    });
  }
  if (isCompleted && hasFailedRows) {
    optionsElements.push({
      key: "Convert failed rows to a test dataset",
      icon: faDatabase,
      action: onCreateFailedDataset,
    });
  }
  if (optionsElements.length > 0) {
    optionsElements.push(MENU_DIVIDER);
  }
  optionsElements.push({
    key: "Delete simulation",
    icon: faTrashCan,
    action: onDelete,
  });

  return (
    <EllipsisOptionsDropdown
      dataLoc="simulation-actions"
      elements={optionsElements}
      ellipsisDirection="vertical"
      timeoutDuration={200}
    />
  );
};
